import { postJson } from './http';
import {
	AddFriendRequestData,
	AppConfigResponseData,
	AppInfo,
	FeedbackRequest,
	InviteRequestData,
	LoginRequestData,
	MultipleSendMsgRequestData,
	NavigationBarResponseData,
	PCLoginRequestData,
	SearchFriendRequestData,
	SecurityProblemRequestData,
	SendMsgRequestData,
	SignupRequestData,
	SmsLoginRequestData,
} from './request';
import {
	AddFiendResponse,
	AppUpgradeInfo,
	AttachConfigResponse,
	BehavioralVerifyCheckBody,
	BehavioralVerifyResponse,
	CaptchaResponse,
	FriendApplyListResponse,
	IntervalPageResponse,
	InviteResponse,
	LoginResponse,
	SystemNotice,
	UserInfoResponse,
} from './response';
import { BlackData } from '../../imsdk/api/friend_black';
import { LoginDevice } from '../../imsdk/db/t_user_devices';
export const clientIp = ( ) =>
	postJson<any, any>("/v1/pc/clientip", {
		body: {},
		useToken: false,
		debug: true
	});

export const PCLogin = (config: PCLoginRequestData) =>
	postJson<LoginResponseData, LoginResponse>("/v1/pc/login", {
		body: config,
		useToken: false,
		debug: true
	});

export const invite = (config: InviteRequestData) =>
	postJson<InviteResponse, any>('/v1/invite', {
		body: config,
		useToken: false,
		debug: true, // Web 环境下总是启用调试
	});

export const attachConfig = () =>
	postJson<AttachConfigResponse, any>('/v1/attachcfg/details', {
		useToken: true,
		debug: true,
	});


export const requestTabBar = () =>
	postJson<NavigationBarResponseData, any>('/v1/sdk/system/navigation/bar', {
		useToken: true,
		debug: true,
	});
export const logout = (otherAuth: { uid: number; token: string }[]) =>
	postJson<any, any>('/v1/logout', {
		body: { other_auth: otherAuth },
		useToken: true,
		debug: true,
	});

export const appConfig = () => postJson<AppConfigResponseData, any>('/v1/sdk/app/config', {});

/**
 * 登录
 * @param config
 */
export type LoginResponseData = AppInfo;


// 获取行为校验图片数据 //TODO:
export const behavioralVerifyGet = (lang: string) => {
	return postJson<BehavioralVerifyResponse, any>('/v1/captcha/get', {
		body: { "lang": lang },
		useToken: false,
		debug: true
	});
}

//TODO:test 提交行为校验图片数据
export const behavioralVerifyCommit = (body: BehavioralVerifyCheckBody) => postJson<any, any>('/v1/captcha/chk', {
	body: body,
	useToken: false,
	debug: true,
});


//获取图形验证码
export const captchaGet = (lang: string) =>
	postJson<CaptchaResponse, any>('/v1/captcha/get', {
		body: { lang },
		useToken: false,
		debug: true,
	});

//验证图形验证码
export const captchaChk = (lang: string, token: string, code: string) =>
	postJson<any, any>('/v1/captcha/chk', {
		body: { lang, token, code },
		useToken: false,
		debug: true,
	});

export const login = (config: LoginRequestData) =>
	postJson<LoginResponseData, LoginResponse>('/v1/login', {
		body: config,
		useToken: false,
		debug: true,
	});

export const SmsLogin = (config: SmsLoginRequestData) =>
	postJson<LoginResponseData, LoginResponse>('/v1/loginotp', {
		body: config,
		useToken: false,
		debug: true,
	});

//检查账号是否存在
export const checkAcApi = (body: {
	account: string; // 账号，可以是用户名、手机、邮箱
	vcode: string; // 服务器编号
	lang: string;
}) =>
	postJson<any, any>('/v1/chkacct', {
		body: body,
		useToken: false,
		debug: true,
	});

//检查手机号码是否存在
export const checkPhone = (
	phone: string, //手机号码
	vcode: string,
	lang: string
) => checkAcApi({ account: phone, vcode: vcode, lang: lang });

export const changePhone = (telno: string, sms_token: string) =>
	postJson<any, any>('/v1/sdk/user/phone/change', {
		body: { telno: telno, sms_token: sms_token },
		useToken: true,
		debug: true,
	});

export const changeEmail = (email: string, email_token: string) =>
	postJson<any, any>('/v1/sdk/user/email/change', {
		body: { email: email, email_token: email_token },
		useToken: true,
		debug: true,
	});

/**
 * 登录设备列表
 * @param null
 */
export const loginDevices = () =>
	postJson<LoginDevice[], any>('/v1/device/info', {
		body: {},
		useToken: true,
		debug: true,
	});



/**
 * 注册
 * @param body
 */
export const register = (body: SignupRequestData) =>
	postJson<any, any>('/v1/signup', {
		body: body,
		useToken: false,
		debug: true,
	});

//邮箱重置密码
export const emailResetPasswd = (
	body: {
		account: string; //账号
		type: string; //类型1-手机号码，2-邮箱
		send_type: string; //类型1-验证手机号码，2-找回密码
		code: string;
		passwd: string; //密码,做个加密，跟消息加密一样，但是秘钥固定
		cid: string; //给解密使用
		vcode: string;
		lang: string;
	},
	useToken: boolean = false
) =>
	postJson<any, any>('/v1/sdk/email/passwd/forget', {
		body: body,
		useToken: useToken,
		debug: true,
	});

//通过验证码重置密码
export const resetPasswdByVerifyCode = (
	body: {
		lang: string; //使用的语言
		vcode: string; //服务器编号 必填 新增字段
		otp_token: string; //短信令牌，新增新版本必填 asd
		passwd: string; //密码,做个加密，跟消息加密一样，但是秘钥固定
		eventTag: string; // 事件标识 ?? 有opt_token 还需要 eventTag 吗
	},
	useToken: boolean = false
) =>
	postJson<any, any>('/v1/resetpwd', {//TODO: 123
		body: body,
		useToken: useToken,
		debug: true,
	});

//发送手机验证码或者邮箱验证码
export const sendVerifyCode = (
	body: {
		send_type: string; //类型10-注册，12-登陆, 13-注销,14-设置手机号码,15-重置密码，16-修改手机号码
		eventTag: string; // 通过/v1/chkacct, 获取到的 事件id 
		captchaToken: string // 行为验证Token
		lang: string;
		vcode: string;
		byEmail: boolean // 是否是邮箱 -- 找回密码流程需要
	},
	useToken: boolean = false
) =>
	postJson('/v1/sdk/otp/send', {
		body: body,
		useToken: useToken,
		debug: true,
	});

export const checkVerifyCode = (body: {
	lang: string;
	vcode: string;
	send_type: string;
	code: string;
	eventTag: string; // 事件标识
}, useToken: boolean = false) =>
	postJson<{ phone: string; otp_token: string }>('/v1/sdk/otp/verify', {
		body: body,
		useToken: useToken,
		debug: true,
	});

export const forgotPsd = (body: {
	account: string; //账号
	security_info: {
		security_problem: string; //安全问题
		security_answer: string; //安全答案
	};
	passwd: string; //密码,做个加密，跟消息加密一样，但是秘钥固定
	vcode: string;
	lang: string;
}) =>
	postJson<any, any>('/v1/sdk/system/reset/password', {
		body: body,
		useToken: false,
		debug: true,
	});

export const userDetail = (uids: number[]) => {
	const res = postJson<UserInfoResponse, any>('/v1/sdk/user/detail', {
		body: { uids: uids },
		useToken: true,
		debug: true,
	});
	return res;
};

//账号删除
export const userDelete = (password: string, sms_token?: string) =>
	postJson<UserInfoResponse, any>('/v1/sdk/user/delete', {
		body: { password: password, sms_token: sms_token },
		useToken: true,
		debug: true,
	});

export const searchFriend = (body: SearchFriendRequestData) =>
	postJson<UserInfoResponse, any>('/v1/sdk/user/search', {
		body: body,
		useToken: true,
		debug: true,
	});

export const addFriend = (body: AddFriendRequestData) =>
	postJson<AddFiendResponse, any>('/v1/sdk/friend/apply/add', {
		body: body,
		useToken: true,
		debug: true,
	});

//申请好友列表
export const friendApplyList = (body: any) =>
	postJson<FriendApplyListResponse, any>('/v1/sdk/friend/apply/list', {
		body: body,
		useToken: true,
		debug: true,
	});

//处理好友申请
export const friendApplyDeal = (body: any) =>
	postJson<any, any>('/v1/sdk/friend/apply/deal', {
		body: body,
		useToken: true,
		debug: true,
	});

//修改用户信息
export const updateUserIfo = (body: { avatar?: string; nick?: string }) =>
	postJson<any, any>('/v1/sdk/user/profile/set', {
		body: body,
		useToken: true,
		debug: true,
	});
//修改密码
export const changePsd = (body: { passwd: string; newPasswd: string }) =>
	postJson<any, any>('/v1/sdk/user/passwd/change', {
		body: body,
		useToken: true,
		debug: true,
	});

//设置密保
export const securityProblem = (body: SecurityProblemRequestData) =>
	postJson<any, any>('/v1/sdk/system/set/security/problem', {
		body: body,
		useToken: true,
		debug: true,
	});
//查询密保
export const qryProblem = () =>
	postJson<
		{
			security_problem: string;
			security_answer: string;
		},
		any
	>('/v1/sdk/system/security/problem', {
		body: {},
		useToken: true,
		debug: true,
	});

//查询账户对应密保问题
export const qryQuestion = (account: string, vcode: string, lang: string) =>
	postJson<
		{
			security_info: {
				security_problem: string; //安全问题
			};
		},
		any
	>('/v1/sdk/system/reset/password/step', {
		body: {
			account: account,
			vcode: vcode,
			lang: lang,
		},
		useToken: true,
		debug: true,
	});

//获取设置群发言间隔列表
export const intervalPage = (body: { tid: string }) =>
	postJson<IntervalPageResponse, any>('/v1/sdk/group/send/msg/interval/page', {
		body: body,
		useToken: true,
		debug: true,
	});
//入群申请列表 type 0 审核中  1 全部
export const joinGroupList = (body: { tid: string; type: number }) =>
	postJson<any, any>('/v1/sdk/group/apply/list', {
		body: body,
		useToken: true,
		debug: true,
	});
//入群申请列表 op 1 同意   2  拒绝
export const joinGroupDeal = (body: { tid: string; applyUid: number; op: number }) =>
	postJson<any, any>('/v1/sdk/group/apply/deal', {
		body: body,
		useToken: true,
		debug: true,
	});

//获取群黑名单列表（禁言列表）
export const groupBlackList = (body: { tid: string }) =>
	postJson<{ members: number[] }, any>('/v1/sdk/group/black/list', {
		body: body,
		useToken: true,
		debug: true,
	});
//加入黑名单 op (0-加入黑名单，1-拉出黑名单)
export const blackOperator = (blackUid: number, op: number) =>
	postJson<any, any>('/v1/sdk/user/black/operator', {
		body: { blackUid: blackUid, op: op },
		useToken: true,
		debug: true,
	});
//加入黑名单 op (0-加入黑名单，1-拉出黑名单)
export const blackList = () =>
	postJson<BlackData, any>('/v1/sdk/user/black/list', {
		useToken: true,
		debug: true,
	});

//删除好友
export const delFriend = (friendUid: string) =>
	postJson<any>('/v1/sdk/friend/delete', {
		body: { friendUid: friendUid },
	});

//检查更新
export const checkForUpdate = () => {
	return postJson<AppUpgradeInfo>('/v1/sdk/app/latest', {
		body: {},
	});
}


//举报列表
export const tipoffList = () => postJson<{ contents: string[] }, any>('/v1/sdk/system/tipoff/list');

export const tipoffSubmit = (body: { target: string; contents: string[] }) => postJson<any>('/v1/sdk/system/tipoff/submit', { body: body });

//操作群管理员
//操作 set - 设置 unset - 取消设置
export const setGroupAdmin = (body: { tid: string; uids: number[]; op: string }) =>
	postJson<any>('/v1/sdk/group/admin', { body: body, debug: true });

//系统公告
export const noticeList = () => postJson<{ notices: SystemNotice[] }>('/v1/sdk/notice/list', { debug: true });

//公告已读
export const noticeModify = (noticeId: string) =>
	postJson<any>('/v1/sdk/notice/modify', { body: { noticeId: noticeId, read: true }, debug: true });

// type 1 帮助，2 关于软件
export const otherText = (type: number) =>
	postJson<{ text: string; url: string }>('/v1/sdk/system/other/text', { body: { type: type }, debug: true });

export const feedback = (body: FeedbackRequest) =>
	postJson<{ text: string; url: string }>('/v1/sdk/system/problem/feedback', { body: body, useToken: true });

export const sendMsg = (body: SendMsgRequestData) => {
	return postJson<{ mid: string; auditWord?: string; auditWordTip?: string }>('/v1/sdk/msg/send', { body: body });
};

export const multipleSendMsgs = (body: MultipleSendMsgRequestData) => {
	return postJson<{ mid: string; auditWord?: string; auditWordTip?: string }>('/v1/sdk/msg/sendbatch', { body: body });
};

export const report = (body: any) => {
	return postJson('/v1/report/record', { body: body });
};

export const reportRegistrationID = (body: { op: number; registration_id: string }) => {
	return postJson('/v1/sdk/push/register/report', { body: body, useToken: true });
};

export const rtcQuery = (body: { rtcId: string }) => {
	return postJson('/v1/sdk/rtc/query', { body: body, useToken: true });
};

export const rtcAnswer = (body: any) => {
	console.log('=====》rtcAnswer', body);
	return postJson('/v1/sdk/rtc/answer', { body: body, useToken: true });
};

export const rtcRequest = (body: { type: string; toTopicId: string; cid: string }) =>
	postJson('/v1/sdk/rtc/request', { body: body, useToken: true });

// 兼容旧版本的 API 调用
export const sendPhoneCode = async (body: {
	phone: string;
	send_type: string;
	sign?: string;
	lang: string;
	vcode: string;
}) => {
	try {
		const checkRes = await checkAcApi({ account: body.phone, vcode: body.vcode, lang: body.lang });
		if (checkRes.code !== 0 || !checkRes.data) {
			return { code: checkRes.code || -1, msg: checkRes.msg || 'Failed to check account' };
		}

		const eventTag = checkRes.data.eventTag;
		if (!eventTag) {
			return { code: -1, msg: 'Failed to get eventTag' };
		}

		return sendVerifyCode({
			send_type: body.send_type,
			eventTag: eventTag,
			captchaToken: '',
			lang: body.lang,
			vcode: body.vcode,
			byEmail: false,
		}, false);
	} catch (error: any) {
		return { code: -1, msg: error?.msg || 'Failed to send code' };
	}
};

export const checkCode = async (body: {
	phone: string;
	send_type: string;
	code: string;
	lang: string;
}) => {
	try {
		const checkRes = await checkAcApi({ account: body.phone, vcode: '', lang: body.lang });
		if (checkRes.code !== 0 || !checkRes.data) {
			return { code: checkRes.code || -1, msg: checkRes.msg || 'Failed to check account' };
		}

		const eventTag = checkRes.data.eventTag;
		if (!eventTag) {
			return { code: -1, msg: 'Failed to get eventTag' };
		}

		return checkVerifyCode({
			lang: body.lang,
			vcode: '',
			send_type: body.send_type,
			code: body.code,
			eventTag: eventTag,
		}, false);
	} catch (error: any) {
		return { code: -1, msg: error?.msg || 'Failed to check code' };
	}
};
